export const selectHasPaid = (state) => state.hasPaid.hasPaid;
export const selectPurchasedBookIds = (state) => state.hasPaid.purchasedBookIds;
export const selectHasPaidLoading = (state) => state.hasPaid.loading;
export const selectHasPaidError = (state) => state.hasPaid.error;
